import { Component, Input } from '@angular/core';
import { OverlayComponent } from '@overlays/overlay/overlay.component';
import { User } from '@services/user.interface';
import { NgStyle } from '@angular/common';
import { HarmonizedShapesComponent } from '../harmonized-shapes/harmonized-shapes.component';
import { WelcomeOverlayComponent } from '../welcome-overlay/welcome-overlay.component';

@Component({
  selector: 'app-start-overlay',
  templateUrl: './start-overlay.component.html',
  styleUrls: ['./start-overlay.component.scss'],
  imports: [NgStyle, HarmonizedShapesComponent, WelcomeOverlayComponent],
})
export class StartOverlayComponent extends OverlayComponent {
  @Input() message: string;
  @Input() user: User;
  @Input() showAnimation: false;

  /**
   * Update the overlay styles based on the viewport size
   */
  override updateOverlayStyles(): void {
    const { playerWidth = 0, playerHeight = 0, browserHeight = 0, browserWidth = 0 } = this.viewportSize || {};

    // Calculate dimensions and position
    let overlayWidth: number | string;
    let leftPosition: number | string;
    let topPosition: number | string;
    let calcMaxHeight: number | string;
    let calcFontSize: number | string;

    // NOTE: Check if browser height is really big or when the
    // browser winodw is narrow. Adjust the overlay to mat
    // the smaller player height and widths.
    const background = `url('/Harmonized_Shapes_Orange_Arctic_Gradient.svg') center center repeat #F9F8F5`;

    if (browserHeight > browserWidth) {
      overlayWidth = playerWidth;
      leftPosition = 0;
      topPosition = 0;
      calcMaxHeight = playerHeight;
      calcFontSize = `smaller`;
    } else {
      overlayWidth = playerWidth;
      leftPosition = 0;
      topPosition = 0;
      calcMaxHeight = playerHeight;
      calcFontSize = `inherit`;
    }

    this.overlayStyles = {
      position: 'absolute',
      top: `${topPosition}px`,
      left: `${leftPosition}px`,
      width: `${overlayWidth}px`,
      height: `${calcMaxHeight}px`,
      fontSize: calcFontSize,
      background: `${background}`,
    };
  }
}
